import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import SoraBold from './assets/Sora-Bold.ttf';

export const CUSTOM_COLOR = '#072B34'; // TODO: update to use theme color
export const fontFamily = "'Sora', -apple-system, BlinkMacSystemFont, sans-serif";

export const translucentButtonStyles = {
  background: 'rgb(224, 228, 234, 0.35)',
  border: `1px solid ${theme.colors.white}`,
  borderRadius: theme.borderRadius.full,
  '&:hover, &:focus': {
    background: 'rgb(224, 228, 234, 0.55)',
  },
  svg: {
    color: theme.colors.neutral90,
  },
};

export const weaveRewindFontFaces = css`
  @font-face {
    font-family: 'Sora-Bold';
    src: url(${SoraBold}) format('truetype');
    font-weight: 100 800;
    font-style: normal;
    font-display: swap;
  }
  /* Apply Sora font to all text elements within Lottie animations */
  .weave-rewind-animation svg text,
  .weave-rewind-animation svg tspan {
    font-family: 'Sora-Bold', DM Sans !important;
  }
  /* Ensure font is applied to all SVG text elements */
  svg[data-lottie] text,
  svg[data-lottie] tspan {
    font-family: 'Sora-Bold', DM Sans !important;
  }
`;
